import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/home_index_linkard_logo.svg'
import _imports_1 from '../assets/images/mine-card-icon-hover.png'
import _imports_2 from '../assets/images/mine-card-icon.svg'
import _imports_3 from '../assets/images/collect-card-icon-hover.png'
import _imports_4 from '../assets/images/collect-card-icon.svg'
import _imports_5 from '../assets/images/linkard_box_icon_hover.png'
import _imports_6 from '../assets/images/linkard_box_icon.svg'
import _imports_7 from '../assets/images/police-regis.png'


const _withScopeId = n => (_pushScopeId("data-v-83553394"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home_content_bg" }
const _hoisted_2 = { class: "mine-content-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "home_linkard_logo",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "联卡", -1))
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "卡包", -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: ""
  })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "卡柜", -1))
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"fotter_view\" data-v-83553394><div class=\"filing_information\" data-v-83553394><span class=\"icp\" data-v-83553394><span data-v-83553394><a href=\"https://beian.cac.gov.cn/\" target=\"_blank\" data-v-83553394>网信算备110105218498801240011号</a></span><span class=\"line\" data-v-83553394>|</span><span data-v-83553394><a href=\"https://beian.miit.gov.cn/\" target=\"_blank\" data-v-83553394>京ICP备2023018406号-2</a></span><span class=\"line\" data-v-83553394>|</span></span><span data-v-83553394><a class=\"police-regis-link\" href=\"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502055796\" target=\"_blank\" data-v-83553394><img class=\"police-regis\" src=\"" + _imports_7 + "\" alt=\"police-regis\" data-v-83553394><span data-v-83553394>京公网安备11010502055796号</span></a></span><span class=\"line\" data-v-83553394>|</span><span data-v-83553394><a href=\"https://o4ernlf37o.feishu.cn/file/Zk3JbG6N5oUEfExRWwjchdqcnUg?from=from_copylink\" target=\"_blank\" data-v-83553394>用户协议</a></span><span class=\"line\" data-v-83553394>|</span><span data-v-83553394><a href=\"https://o4ernlf37o.feishu.cn/file/EW6Lb8Iu4o6LHpx7PDYc6R5SnQb?from=from_copylink\" target=\"_blank\" data-v-83553394>隐私政策</a></span></div></div>", 1)
const _hoisted_17 = { class: "bind-phone-container" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "绑定手机号后即可创建", -1))
const _hoisted_19 = { class: "main" }
const _hoisted_20 = { class: "phone-box" }
const _hoisted_21 = { class: "password-box" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "submit-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.bindPhoneVisible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "card-item card-mine-item",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toLinkardPage && _ctx.toLinkardPage(...args)))
          }, _hoisted_7))
        : _createCommentVNode("", true),
      (!_ctx.bindPhoneVisible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "card-item card-collect-item",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toCollectPage && _ctx.toCollectPage(...args)))
          }, _hoisted_11))
        : _createCommentVNode("", true),
      (_ctx.haveCabinet && !_ctx.bindPhoneVisible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "card-item card-collect-item",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toCabinet && _ctx.toCabinet(...args)))
          }, _hoisted_15))
        : _createCommentVNode("", true)
    ]),
    _hoisted_16,
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.bindPhoneVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.bindPhoneVisible) = $event)),
      "show-close": false,
      "align-center": "",
      center: "",
      "before-close": _ctx.handleBeforeClose
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.phone,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.phone) = $event)),
                placeholder: "请输入手机号",
                maxlength: "11"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.code,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.code) = $event)),
                placeholder: "请输入验证码",
                maxlength: "6"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", {
                class: "code",
                round: "",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.sendCode && _ctx.sendCode(...args))),
                disabled: _ctx.isSending || _ctx.countdown > 0
              }, _toDisplayString(_ctx.isSending ? "" : _ctx.countdown > 0
                ? `${_ctx.countdown}秒后重试`
                : "获取验证码"), 9, _hoisted_22)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_el_button, {
                round: "",
                onClick: _ctx.bindPhoneRequest
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确认")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ]))
}